



































import _ from "lodash";
import { Component, Vue, Prop } from 'vue-property-decorator';
import formatNumber from '@/shared/filters/format-number';
@Component
export default class VoucherDetail extends Vue {
    @Prop({default: []})
    private voucher_details: any;
    @Prop({default: ''})
    private voucher_code: any;
    private transformNumb(value: number, format: string) {
        if (!(value > 0)) {
            return '0';
        }
        return formatNumber(value, format);
    }
    private closePopup() {
        this.$emit("closePopup");
    }
}

